import type { MonthGroup } from '@/cmsBackend/transformers/types/featureAnnouncement';
import {
  CONTAINER_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
} from '@/common/constants';
import { replaceTemplateTokens } from '@/common/helpers/templateTokens';
import { useModuleStyles } from '@/common/hooks/useModuleStyles';
import { AnnouncementCard } from '@/components/modules/AnnouncementCard';
import React from 'react';
import styles from './MonthGroupSection.module.scss';

export interface MonthGroupSectionProps {
  monthGroup: MonthGroup;
  heading: string;
}

export const MonthGroupSection: React.FC<MonthGroupSectionProps> = ({ monthGroup, heading }) => {
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container: CONTAINER_OPTIONS.UNCONTAINED,
    fillType: MODULE_FILL_TYPE_OPTIONS.BASE,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    moduleClassName: 'module-month-group',
    styles,
  });

  return (
    <section className={sectionStyles}>
      <div className={moduleBaseStyles}>
        <div className={styles.section__header}>
          <p className={styles.section__monthLabel}>{monthGroup.label}</p>
          <span className={styles.section__badgeGreen}>
            {replaceTemplateTokens(heading, {
              count: monthGroup.count,
              month: monthGroup.monthName,
              year: monthGroup.year,
            })}
          </span>
        </div>
        <div className={styles.section__cards}>
          {monthGroup.majorAnnouncements.map((card) => (
            <AnnouncementCard key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};
